import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Fragment, memo } from 'react';

import UserAvatar from '@/components/UserAvatar';
import { useGetOneUser } from '@/modules/admin/hooks/useUser';

const RenderUser = ({ user, className, textClassName, showAvatar = true, hideName, defaultValue, ...rest }) => {
  return (
    <div className={classNames(className, 'flex flex-row items-center')}>
      {showAvatar && <UserAvatar user={user} {...rest}/>}
      {!hideName &&
        <span
          className={classNames(textClassName, 'truncate', { 'ml-2 ': showAvatar })}>{user?.fullName || defaultValue}</span>}
    </div>
  );
};

const UserFromServer = ({ id, ...rest }) => {
  const { isLoading, data } = useGetOneUser({ id }, { refetchOnWindowFocus: false });
  if (!data || isLoading) return <Fragment/>;
  
  return <RenderUser user={data.data} {...rest}/>;
};

const User = ({ user, defaultValue, ...rest }) => {
  if (!user) return defaultValue ? <RenderUser defaultValue={defaultValue} {...rest}/> : <Fragment/>;
  if (typeof user === 'string') return <UserFromServer id={user} defaultValue={defaultValue} {...rest}/>;
  return <RenderUser user={user} defaultValue={defaultValue} {...rest}/>;
};

export default memo(User);

UserFromServer.propTypes = {
  id: PropTypes.string
};

RenderUser.propTypes = {
  className: PropTypes.string,
  hideName: PropTypes.bool,
  defaultValue: PropTypes.any,
  showAvatar: PropTypes.bool,
  textClassName: PropTypes.string,
  user: PropTypes.object
};

User.propTypes = {
  className: PropTypes.string,
  hideName: PropTypes.bool,
  showAvatar: PropTypes.bool,
  defaultValue: PropTypes.any,
  textClassName: PropTypes.string,
  user: PropTypes.any
};
